
import React from 'react';
import { ArrowRight } from 'lucide-react';

export const HeroSection = () => {
  return (
    <section className="pt-32 pb-20 bg-gradient-to-b from-blue-50 to-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-brand-darkgrey mb-6 leading-tight">
            Find hires without losing hours.
            <span className="relative">
              {" "}
              <svg 
                className="absolute bottom-[-10px] left-0 w-full h-4 text-brand-yellow z-[-1]" 
                viewBox="0 0 300 20" 
                xmlns="http://www.w3.org/2000/svg"
              >
                <path 
                  d="M10 10 Q150 20, 290 10" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="4" 
                  strokeLinecap="round"
                />
              </svg>
            </span>
          </h1>
          <h2 className="text-xl md:text-2xl text-brand-grey mb-10 leading-relaxed">
            Cutshort combines India's largest premium tech talent pool with the technology to help you make offers in as soon as 48 hours and with 80% less effort.
          </h2>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="http://cutshort.io/?auth=employer" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center justify-center bg-brand-blue text-white px-8 py-4 rounded-full text-lg font-medium hover:bg-brand-blue/90 transition-colors"
            >
              Start for free
              <ArrowRight className="w-5 h-5 ml-2" />
            </a>
            <a
              href="https://cutshort.io/a/generic-emp-form"
              target="_blank"
              rel="noopener noreferrer" 
              className="flex items-center justify-center gap-2 px-8 py-4 rounded-full text-lg font-medium text-brand-blue border border-brand-blue/30 hover:border-brand-blue/60 hover:bg-brand-blue/5 transition-colors"
            >
              Get a callback
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
